import React from 'react'

import { useOverlayIds } from '../hooks'

import OverlayListItem from './OverlayListItem'

import styles from './OverlayList.module.css'

const OverlayList = () => {
  const overlayIds = useOverlayIds()

  return (
    <ul className={styles.list}>
      {overlayIds.map(overlayId => (
        <OverlayListItem id={overlayId} key={overlayId} />
      ))}
    </ul>
  )
}

export default OverlayList
